export default "__VITE_ASSET__Bv_kezT5__"